module.exports = __webpack_public_path__ + "img/半夏.aa446452.jpg";